// frontend/src/components/ComingSoonCarousel.js

import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './ComingSoonCarousel.css'; // Dedicated CSS file
import './Skeleton.css';

import SkeletonCard from './SkeletonCard';

const ComingSoonCarousel = ({ publicSpices = [] }) => {
    const [displaySpices, setDisplaySpices] = useState([]);

    const swiperBreakpoints = {
        480: { slidesPerView: 2, spaceBetween: 15 },
        640: { slidesPerView: 2, spaceBetween: 20 },
        768: { slidesPerView: 3, spaceBetween: 30 },
        1024: { slidesPerView: 4, spaceBetween: 40 },
    };

    useEffect(() => {
        if (publicSpices.length > 0) {
            // Filter: ONLY show items where isComingSoon is true
            const filtered = publicSpices.filter(s => s.isComingSoon === true);
            setDisplaySpices(filtered);
        }
    }, [publicSpices]);

    const renderCarouselContent = () => {
        if (publicSpices.length === 0) {
             const numberOfSkeletonsToRender = 4;
            return (
                <Swiper
                    modules={[Navigation, Pagination, A11y]}
                    slidesPerView={2}
                    spaceBetween={10}
                    navigation
                    pagination={{ clickable: true }}
                    breakpoints={swiperBreakpoints}
                >
                    {[...Array(numberOfSkeletonsToRender)].map((_, index) => (
                        <SwiperSlide key={`skeleton-${index}`}>
                            <SkeletonCard />
                        </SwiperSlide>
                    ))}
                </Swiper>
            );
        }

        if (displaySpices.length === 0) {
            return null; // Don't show anything if no coming soon items
        }

        return (
            <Swiper
                modules={[Navigation, Pagination, A11y]}
                slidesPerView={2}
                spaceBetween={10}
                navigation
                pagination={{ clickable: true }}
                breakpoints={swiperBreakpoints}
            >
                {displaySpices.map(spice => {
                    const imageUrl = spice.imageUrls && spice.imageUrls.length > 0
                        ? spice.imageUrls[0]
                        : spice.imageUrl;

                    return (
                        <SwiperSlide key={spice._id}>
                            {/* CHANGED: Unique class names to prevent bleeding to Featured Products */}
                            <div className="coming-soon-card">
                                <div className="coming-soon-inner-content">
                                    <div className="coming-soon-image-wrapper">
                                        <img
                                            src={imageUrl || 'https://placehold.co/300x200/cccccc/000000?text=No+Image'}
                                            alt={spice.name}
                                            className="coming-soon-image"
                                            onError={(e)=>{e.target.onerror = null; e.target.src='https://placehold.co/300x200/cccccc/000000?text=No+Image'}}
                                        />
                                        {/* Coming Soon Badge Overlay */}
                                        <div className="coming-soon-badge">Coming Soon</div>
                                    </div>

                                    <div className="coming-soon-info">
                                        <h3>{spice.name}</h3>
                                        
                                        {/* REMOVED: Description tag is deleted here */}

                                        {/* NO PRICE, NO BUY BUTTON */}
                                        <div className="coming-soon-actions">
                                            <button className="coming-soon-disabled-button" disabled>
                                                Coming Soon
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        );
    };

    if (displaySpices.length === 0 && publicSpices.length > 0) return null;

    return (
        // CHANGED: Unique wrapper and section classes
        <div className="coming-soon-main-wrapper">
            <section className="coming-soon-section">
                <div className="section-header-row">
                    <h2 className="section-title">Coming Soon</h2>
                </div>
                {renderCarouselContent()}
            </section>
        </div>
    );
};

export default ComingSoonCarousel;